export default "__VITE_ASSET__nWj_K2lY__"